import { createContext } from 'react'
import axios, { AxiosInstance } from 'axios'

type ClientContext = {
  gsClient: AxiosInstance
  client: AxiosInstance
}

export const ClientContext = createContext<ClientContext>({
  gsClient: axios,
  client: axios
})
